const VideoHost = {
  Youtube: 1,
};

export default VideoHost;
